import { Check } from 'models/Check';
import { Service } from 'models/Service';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Card, CardBody } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { RootState } from 'store/store';
import CheckServiceAddFormVersion from './CheckServiceAddFormVersion';
import ServiceCheckRowAdd from './ServiceCheckRowAdd';
import { useOfficeTranslation } from 'i18n/OfficeTranslation';


interface Props {
    service: Service;
}

interface Actions {
    setService: (s: Service) => void;
}


const CheckManagmentCardAdd: React.FC<Props & Actions> = ({ service, setService }) => {
    const { t } = useOfficeTranslation();
    const [add, setAdd] = useState<boolean>(false)
    const [checks, setChecks] = useState<Check[]>([])

    useEffect(() => {
        setChecks(service.checks)
    }, [service.checks])


    return (
        <Card>
            <CardBody>
                <div>
                    <p className="text-muted text-uppercase fw-semibold md-0" style={{ fontSize: "13px" }}>{t("common.checks")}</p>
                </div>
                <hr />
                {
                    !add ?
                        checks.map((check, i) => {
                            return <ServiceCheckRowAdd setService={setService} service={service} check={check} index={i} setChecks={setChecks} />
                        })
                        : <CheckServiceAddFormVersion setService={setService} service={service}
                            onCancel={() => {
                                setAdd(false);
                            }
                            }
                            save={() => {
                                setAdd(false);
                            }}
                            setChecks={setChecks}
                        />
                }


                {!add && <div className="mt-3">
                    <button
                        id="buttonPerson"
                        name="buttonPerson"
                        type="button"
                        onClick={() => {
                            setAdd(true);
                        }}
                        className="btn btn-primary w-100 waves-effect waves-light"
                    >
                        {t("common.addCheck")}
                    </button>
                </div>}

            </CardBody>
        </Card >
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        servicesState: state.Services
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckManagmentCardAdd);
